import {
  Box,
  Fade,
  Paper,
  Popper,
  PopperPlacementType,
  Typography,
} from "@mui/material";
import React, { useEffect, useRef, useState } from "react";
import "./index.css";
import mathFunction from "../../exams/mathFunction";
import { FontFamily } from "../Preview/getAlphabetForIndex";
import PreviewComponent from "../../mockTest/QuestionFormComponentMock/previewComponent";

function MessagePopper({
  text,
  id,
  type,color
}: {
  text?: string;
  id: string;
  type?: "ck";
  color?:any
}) {
  // const [anchorEl, setAnchorEl] = useState<HTMLButtonElement | null>(null);
  // const [open, setOpen] = useState(false);
  // const [placement, setPlacement] = useState<PopperPlacementType>();
  // const [overflow, setOverflow] = useState(false);

  const paragraphRef = useRef<HTMLDivElement>(null);

  // const handleClick = (event: React.MouseEvent<HTMLButtonElement>) => {
  //   setAnchorEl(event.currentTarget);
  //   setOpen((prev) => placement !== "bottom" || !prev);
  //   setPlacement("bottom");
  // };

  // const handleClose = () => setOpen(false);

  // useEffect(() => {
  //   const handleOutsideClick = (event: MouseEvent) => {
  //     if (anchorEl && !anchorEl.contains(event.target as Node)) {
  //       handleClose();
  //     }
  //   };
  //   document.body.addEventListener("click", handleOutsideClick);
  //   return () => document.body.removeEventListener("click", handleOutsideClick);
  // }, [anchorEl]);

  useEffect(() => {
    const addEllipsisIfNeeded = async () => {
      const paragraph = paragraphRef.current;
      if (!paragraph) return;

      const isOverflowing = (el: HTMLElement) =>
        el.scrollHeight > el.clientHeight || el.scrollWidth > el.clientWidth;

      const findLastVisibleWord = async (words: string[]) => {
        let left = 0;
        let right = words.length - 1;

        while (left <= right) {
          const mid = Math.floor((left + right) / 2);
          paragraph.textContent = words.slice(0, mid + 1).join(" ");
          await new Promise((resolve) => requestAnimationFrame(resolve));

          if (isOverflowing(paragraph)) {
            right = mid - 1;
          } else {
            left = mid + 1;
          }
        }
        return right;
      };

      if (paragraph.textContent && isOverflowing(paragraph)) {
        const words = paragraph.textContent.split(" ");
        const lastVisibleIndex = await findLastVisibleWord(words);
        paragraph.textContent =
          words.slice(0, lastVisibleIndex + 1).join(" ") + "...";
        // setOverflow(true);
      }

      mathFunction(); // typeset math after truncation
    };

    if (text) addEllipsisIfNeeded();
  }, [id, text]);

  return (
    <Box
      ref={paragraphRef}
      sx={{
        whiteSpace: "pre-wrap",
        maxHeight: "100%",
        width: "100%",
        textOverflow: "ellipsis",
        fontSize: "0.75rem",
        "& img": {
          maxWidth: "100%",
          maxHeight: "30px !important",
        },
        // textDecoration:color?"underline":""
      }}
      color={color?color:"#121212"}
      fontWeight={color?600:400}
      fontSize={"16px"}
      lineHeight={"125%"}
      fontFamily={FontFamily.gilroy}
    >
      <PreviewComponent htmlContent={text ?? ""} />
    </Box>
  );
}

export default MessagePopper;
